export default __webpack_public_path__ + "static/media/close-gold.561f2c4c.svg";